<lp-collection-info
  *ngIf="selectedCollectionId || collectionMode === 'create'; else collectionListTmp"
  [mode]="collectionMode"
  [id]="selectedCollectionId"
  [unionId]="unionId"
  [ref]="ref"
  (cancelEditing)="onCancelEditing()"
  (saved)="onSaveCollection($event)"
  (deleted)="onDeleteCollection()"
  (onClickEditButton)="onClickEditButton()"
></lp-collection-info>

<ng-template #collectionListTmp>
  <lp-collection-list
    (onSelectCollection)="onSelectCollection($event)"
    (startCreate)="onClickCreateButton()"
  ></lp-collection-list>
</ng-template>
